/*
 * @Description: 
 * @Author: ywj
 * @Date: 2023-12-20 10:30:15
 * @LastEditTime: 2025-02-18 15:50:11
 * @LastEditors: Please set LastEditors
 */
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import commomReducer from './common';
import userReducer from '../features/user/userSlice'
import addressReducer from './address';
import orderReducer from './order';

export const store = configureStore({
  reducer: {
    common: commomReducer,
    user: userReducer,
    addressReducer: addressReducer,
    orderReducer: orderReducer,
  },
});

export const dispatch = store.dispatch;
export const getState = store.getState;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
